
import { useContext } from 'react';
import { AdapterDefCrudService } from '../../apis/mgmt/AdapterDefCrudService';
import { AdapterDef, findAdapterDefByAgent } from '../../apis/mgmt/api';
import { useReadOnly, readOnly } from '../common/DataView';
import { useStatefulApiEditable } from '../common/Editable';
import { useApiFilteredList, useApiFilteredPaginatedList } from '../common/FilteredPaginatedList';
import { ListProps, SectionListLayout, useListWithEditable, useStatefulList } from '../common/List';
import { Modal } from '../common/Modal';
import { useStatefulToggleable } from '../common/Toggleable';
import { AdapterDefCard } from './AdapterDefCard';
import { AdapterDefEditable } from './AdapterDefEditable';
import { Auth, Role } from '../../apis/Auth';


export const useAdapterDefListByAgent = function (props: {
    agentId: string | undefined,
}) {
    return useApiFilteredPaginatedList<string, AdapterDef>({
        filterProps: useReadOnly(props.agentId),
        listProps: useStatefulList<AdapterDef>(),
        pagingProps: { pageSize: 1000 },
        filterToQueryParams: (agentId: string) => ({ agentId }),
        apiQueryFunc: findAdapterDefByAgent
    });
};

export function AdapterDefSectionList(props: {
    listProps: ListProps<AdapterDef>,
    defaultAddItemData?: AdapterDef
}) {

    const toggle = useStatefulToggleable(false);
    const { listProps, editableProps } = useListWithEditable<AdapterDef>({
        listProps: props.listProps,
        editableProps: useStatefulApiEditable(AdapterDefCrudService, undefined, undefined, toggle),
        toggle: toggle,
        defaultAddItemData: props.defaultAddItemData,
    });

    const { onAddItem, onEditItem } = listProps;
    const { is } = useContext(Auth);

    return (
        <>
            <SectionListLayout title="Adaptadores" onCreateClick={is(Role.TECHNICIAN) && onAddItem || undefined}>
                {listProps.data && listProps.data.map((itemData: AdapterDef, index: number) => (
                    <AdapterDefCard
                        key={itemData.id}
                        data={itemData}
                        setData={(data) => listProps.setItemOrDeleteOld(data, itemData)}
                        onClick={onEditItem}
                    />
                ))}
            </SectionListLayout>

            <Modal mode="FullPage" 
                title={editableProps.data?.id? "Editando adaptador" : "Nuevo adaptador"}
                toggle={toggle} onCancel={editableProps.cancel} 
            >
                <AdapterDefEditable {...editableProps} />
            </Modal>
        </>
    );

}